import { useState } from 'react'
import { useLocation } from 'react-router-dom'

import { Box, NotFound } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import Headline from 'modules/nps/components/Headline'
import SurveyBody from 'modules/nps/components/SurveyBody'
import { SurveyThankYou } from 'modules/nps/components/SurveyThankYou'
import { useNpsForm } from 'modules/nps/hooks/useNpsForm'
import { NpsAvailableModule } from 'modules/nps/lib/types'
import { getNpsVisibility } from 'modules/nps/lib/visibility'

const ProductNpsPage = () => {
  const [surveyAnswered, setSurveyAnswered] = useState(false)
  const { pathname } = useLocation()
  const { navigation } = useNavigation()
  const productPath = pathname.match(/^\/nps\/([^\/]+)$/)?.[1] || ''
  // eslint-disable-next-line no-type-assertion/no-type-assertion
  const config = getNpsVisibility(navigation)[productPath as NpsAvailableModule]

  useEffect(() => {
    if (!productPath) return

    track(trackingEvents.nps.visitsNpsPage, { path: productPath })
  }, [productPath])

  const onSuccess = () => {
    setSurveyAnswered(true)

    track(trackingEvents.nps.submitNpsAnswer, { path: productPath })
  }
  const { onChange, values, onSubmit, isSubmitting } = useNpsForm(productPath, onSuccess)

  if (!productPath || !config)
    return (
      <NotFound
        title={i18n.t('nps.survey_page.error.title')}
        description={i18n.t('nps.survey_page.error.description')}
      />
    )

  if (surveyAnswered)
    return (
      <SurveyThankYou
        productIcon={config.icon}
        productName={config.productName}
        score={values.scoring}
      />
    )

  return (
    <Box gap="s64">
      <Headline
        text={i18n.t('nps.survey_page.headline.title', { productName: config.productName })}
        icon={config.icon}
      />
      <SurveyBody
        productName={config.productName}
        onChange={onChange}
        values={values}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
      />
    </Box>
  )
}

export default ProductNpsPage
